const ComposeSvg = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.36744 2.26512H2.19276C1.87642 2.26512 1.57304 2.39079 1.34935 2.61447C1.12567 2.83816 1 3.14155 1 3.45789V11.8072C1 12.1236 1.12567 12.427 1.34935 12.6507C1.57304 12.8743 1.87642 13 2.19276 13H10.5421C10.8585 13 11.1618 12.8743 11.3855 12.6507C11.6092 12.427 11.7349 12.1236 11.7349 11.8072V7.63256"
      stroke="#00AB6B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.8404 1.37054C11.0776 1.13329 11.3994 1 11.735 1C12.0705 1 12.3923 1.13329 12.6295 1.37054C12.8668 1.6078 13.0001 1.92959 13.0001 2.26512C13.0001 2.60065 12.8668 2.92244 12.6295 3.15969L6.9639 8.82532L4.57837 9.42171L5.17475 7.03618L10.8404 1.37054Z"
      stroke="#00AB6B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ComposeSvg;
